import { datadogRum } from "@datadog/browser-rum";

/**
 * Tracks e2e image generation latency from when a batch is added
 * to when polling reports it as complete. Reports timing to Datadog RUM.
 */

const startTimes = new Map<number, number>();

export function startGenerationTimer(batchId: number) {
  startTimes.set(batchId, performance.now());
}

export function completeGenerationTimer(batchId: number, context?: Record<string, string | number | boolean>) {
  const startTime = startTimes.get(batchId);
  if (startTime == null) return;

  const durationMs = performance.now() - startTime;
  startTimes.delete(batchId);

  datadogRum.addAction("image_generation_e2e", {
    duration_ms: Math.round(durationMs),
    batch_id: batchId,
    ...context
  });
}
